import React, {Component} from 'react';

export const CdnPath = ( siteId, name, directory=false, width=false, height=false, params=false ) => {

	let url = '';
	let cdn = '';

	if( siteId == 17 ) {
		cdn = 'https://cdn.henpartydeals.com';
	} else {
		cdn = 'https://dcdn.thestagcompany.com';
	}

	let q = [];
	if( width) {
		q.push( 'w=' + width );
	}
	if( height ) {
		q.push( 'h=' + height );
	}
	if( params) {
		q.push( params );
	}

	const queryStr = q.length > 0 ? '?' + q.join('&') : "";

	const path = directory ? directory + '/' + name : name;
	return cdn + '/' + path +  queryStr;

};

export const CdnImage = props => {
	const url = CdnPath( props.siteId, props.name, props.directory, props.width, props.height, props.params );
	return (
		<img src={url} alt={props.alt} className={props.class} />
	)
}

export const StaticImage = ( {siteId, imagePath, alt, cssClass }) => {

	let domain;

	let classes = cssClass || '';

	if( siteId == 17 ) {
		domain = 'https://static.henpartydeals.com';
	} else {
		domain = 'https://static.thestagcompany.com';
	}

	return (
		<img src={`${domain}/${imagePath}`} alt={alt} className={classes} />
	)

}

export const UnconfirmedHotelImage = (standardId) => {
	if(typeof standardId!== "undefined"){
		switch(parseInt(standardId)){
			case 1://Budget
				return <StaticImage siteId={siteId} imagePath="global/img/accommodation/budget-hotel.jpg" alt="Example of a budget hotel" cssClass="image full-width height-150-mob radius mg-b-tch" />
			case 3: //Superior
				return <StaticImage siteId={siteId} imagePath="global/img/accommodation/4-hotel.jpg" alt="Example of a superior hotel" cssClass="image full-width radius height-150-mob mg-b-tch" />
			case 4://Self catering
				return <StaticImage siteId={siteId} imagePath="global/img/accommodation/central-standard.jpg" alt="Example of a self catering hotel" cssClass="image full-width radius height-150-mob mg-b-tch" />
			case 5: //House
				return <StaticImage siteId={siteId} imagePath="global/img/accommodation/house.jpg" alt="Example of a house" cssClass="image full-width radius height-150-mob mg-b-tch" />
			default://Standard
				return <StaticImage siteId={siteId} imagePath="global/img/accommodation/standard-hotel.jpg" alt="Example of a standard hotel" cssClass="image full-width radius height-150-mob mg-b-tch" />
		}
	} else {
		return <StaticImage siteId={siteId} imagePath="global/img/accommodation/standard-hotel.jpg" alt="Example of a standard hotel" cssClass="image full-width radius height-150-mob mg-b-tch" />
	}
}